module.exports = __webpack_public_path__ + "static/full-slider-placeholder-3a7730e9bc472890921fd36b69916f3c.jpg";